/**
 * Origin of a Pulse definition (check, track, fact collector). `config`
 * definitions come from static YAML and are read-only; `db` definitions are
 * UI-managed and editable.
 */
export const DEFINITION_SOURCES = ['config', 'db'] as const;

export type DefinitionSource = (typeof DEFINITION_SOURCES)[number];
